<template>
  <div class="appraise-detail container">
    <div class="title">
      <el-button
        type="text"
        icon="el-icon-arrow-left"
        class="back-btn"
        @click="$router.go(-1)"
        >返回列表</el-button
      >
      <b>{{ $route.query.nickName }}的素养成绩</b>
      <div class="btn-box">
        <el-button
          type="primary"
          plain
          icon="el-icon-circle-plus-outline"
          size="mini"
          @click="scoreDetail.otherList.push({ label: '', score: 0 })"
          >新增成绩项目</el-button
        >
        <el-button type="primary" size="mini" @click="handleSubmit"
          >完成评分</el-button
        >
      </div>
    </div>
    <div class="main">
      <div class="box" v-for="(item, idx) in list" :key="idx">
        <p class="box_title">{{ item.title }}</p>
        <div class="content">
          <div class="one_row" v-for="(row, idx) in item.items" :key="idx">
            <!-- <span>{{ idx + 1 }}.</span> -->
            <span style="margin-right: 20px">{{ row.name }}</span>
            <el-input-number
              v-model="scoreDetail[row.score]"
              :min="0"
              :max="4"
              size="small"
              :controls="false"
            ></el-input-number>
          </div>
        </div>
      </div>
      <template v-if="scoreDetail.otherList.length > 0">
        <div
          class="box otherList"
          v-for="(item, i) in scoreDetail.otherList"
          :key="i + 9"
        >
          <p class="box_title">
            课堂素养考核{{ i + 1 }}
            <i class="el-icon-close" @click="handleDel(i)"></i>
          </p>
          <div class="content" style="text-align: left">
            <el-form :model="item" ref="form" size="small" label-width="50px">
              <el-form-item label="项目:" prop="label">
                <el-select
                  v-model="item.label"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择项目"
                >
                  <el-option
                    v-for="o in options"
                    :key="o"
                    :label="o"
                    :value="o"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分数:" prop="score">
                <el-input-number
                  v-model="item.score"
                  :min="-10"
                  :max="10"
                ></el-input-number>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <!-- <div class="box btn-box">
        <el-button
          v-show="!info.syComplete"
          type="primary"
          icon="el-icon-coin"
          @click="handleSubmit"
          >提交评分</el-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import { appraiseDetail, saveAppraise } from "@/api/chapter";

export default {
  props: {
    info: Object,
  },
  data() {
    return {
      list: [
        {
          title: "领导与团队",
          items: [
            {
              name: "领导潜力",
              score: "cxys",
            },
            {
              name: "团队贡献",
              score: "hzdd",
            },
            {
              name: "冲突解决",
              score: "fzxy",
            },
          ],
        },
        {
          title: "自我管理",
          items: [
            {
              name: "自我认知",
              score: "gjys",
            },
            {
              name: "时间管理",
              score: "zzrt",
            },
            {
              name: "自律性",
              score: "whzx",
            },
          ],
        },
        {
          title: "艺术与审美",
          items: [
            {
              name: "艺术鉴赏",
              score: "qqsy",
            },
            {
              name: "艺术创作",
              score: "zzcy",
            },
            {
              name: "审美提升",
              score: "stcs",
            },
          ],
        },
        {
          title: "情感素养",
          items: [
            {
              name: "情绪管理",
              score: "rwjd",
            },
            {
              name: "同理心",
              score: "rwqh",
            },
          ],
        },
        {
          title: "科技素养",
          items: [
            {
              name: "科技知识",
              score: "cszz",
            },
            {
              name: "创新思维",
              score: "lxsw",
            },
            {
              name: "技术应用",
              score: "yyyj",
            },
          ],
        },
        {
          title: "国际视野",
          items: [
            {
              name: "语言能力",
              score: "gwjs",
            },
            {
              name: "文化理解",
              score: "cybd",
            },
          ],
        },
        {
          title: "自我提升",
          items: [
            {
              name: "学习态度",
              score: "lxsx",
            },
            {
              name: "自主学习能力",
              score: "qyfs",
            },
            {
              name: "反思与总结",
              score: "szxx",
            },
          ],
        },
        {
          title: "公民意识",
          items: [
            {
              name: "社会责任感",
              score: "zasm",
            },
            {
              name: "公民权利与义务",
              score: "jqrg",
            },
            {
              name: "公共参与",
              score: "sxfz",
            },
          ],
        },
        {
          title: "综合应用",
          items: [
            {
              name: "跨学科理解",
              score: "rald",
            },
            {
              name: "综合解决问题",
              score: "ppzy",
            },
            {
              name: "创新能力",
              score: "wtjj",
            },
          ],
        },
      ],
      scoreDetail: {
        classChapterId: null,
        userId: null,
        cxys: 3,
        hzdd: 3,
        fzxy: 3,
        stcs: 3,
        gjys: 3,
        zzrt: 3,
        whzx: 3,
        qqsy: 3,
        zzcy: 3,
        rwjd: 3,
        rwqh: 3,
        cszz: 3,
        lxsw: 3,
        yyyj: 3,
        gwjs: 3,
        cybd: 3,
        lxsx: 4,
        qyfs: 4,
        szxx: 3,
        zasm: 3,
        jqrg: 4,
        sxfz: 3,
        rald: 4,
        ppzy: 4,
        wtjj: 3,
        otherList: [],
      },
      options: [
        "上课期间手机未上交",
        "玩手机、玩电脑（打开与上课无关页面）",
        "嬉笑打闹、大声喧哗",
        "上课睡觉",
        "不交作业",
        "迟到或未按时签到",
        "老师讲课期间戴耳机",
        "自己随意调换座位",
        "上课期间组员不得去其他组",
        "上课带零食、吃零食、带杯装饮料等进实训室",
        "积极参与回答问题",
        "积极组织讨论",
        "优秀作业",
        "遵守纪律",
        "积极提问（问作业做什么的除外）",
        "小组全部交齐作业",
        "认真听课记笔记",
        "辅助老师完成工作",
      ],
    };
  },
  activated() {
    this.getDetail();
  },
  deactivated() {
    this.scoreDetail = this.$options.data().scoreDetail;
  },
  methods: {
    getDetail() {
      let classChapterId = this.$route.query.classChapterId;
      let userId = this.$route.query.userId;
      this.$loading.show();
      appraiseDetail({ classChapterId, userId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          if (res.data) this.scoreDetail = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDel(idx) {
      this.$confirm("确定要删除该项吗?", {
        type: "warning",
      })
        .then(() => {
          this.scoreDetail.otherList.splice(idx, 1);
        })
        .catch(() => {});
    },
    handleSubmit() {
      this.scoreDetail.classChapterId = this.$route.query.classChapterId;
      this.scoreDetail.userId = this.$route.query.userId;
      this.$loading.show();
      delete this.scoreDetail.total;
      saveAppraise(this.scoreDetail).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("评分成功");
          this.getDetail();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.appraise-detail {
  padding: 20px 0;
  height: 100%;
  overflow: inherit;
  .title {
    position: relative;
    height: 52px;
    line-height: 52px;
    text-align: center;
    border-radius: 2px;
    // background-color: #fff;
    // box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
    .back-btn {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
    b {
      font-size: 20px;
    }
    .btn-box {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
    .stundent-name {
      position: absolute;
      right: 140px;
      top: 50%;
      transform: translateY(-50%);
      span {
        color: #1890ff;
      }
    }
  }
  .main {
    margin: 10px 0;
    text-align: left;
    height: calc(100% - 52px - 20px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }
    .box {
      display: inline-block;
      margin: 30px;
      width: 330px;
      height: 330px;
      border-radius: 50%;
      overflow: hidden;
      text-align: center;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
      vertical-align: top;
      &.plus {
        position: relative;
        line-height: 330px;
        background-color: #fff;
        cursor: pointer;
        &:hover {
          .el-icon-circle-plus {
            color: teal;
          }
        }
        .el-icon-circle-plus {
          margin-top: 100px;
          font-size: 80px;
          color: #606266;
          transition: all 0.3s ease;
        }
        .add-tips {
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          line-height: 1;
          font-size: 16px;
          color: #909399;
          p {
            margin-bottom: 10px;
          }
        }
      }
      .box_title {
        padding: 0 10px;
        height: 60px;
        line-height: 60px;
        font-size: 20px;
        background-color: #fff;
        font-weight: 600;
        color: teal;
        .el-icon-close {
          float: right;
          margin-top: 15px;
          font-size: 20px;
          transition: all 0.3s ease;
          cursor: pointer;
          &:hover {
            color: #f56c6c;
          }
        }
      }
      .content {
        padding: 30px;
        height: 270px;
        background-color: #fff;
        .one_row {
          //   padding: 6px 0;
          margin-bottom: 10px;
          font-size: 16px;
        }

        ::v-deep .memo-input {
          margin-top: 10px;
          .el-textarea__inner {
            font-family: inherit;
            color: inherit;
          }
        }
      }
      &.btn-box {
        box-shadow: inherit;
        line-height: 268px;
      }
    }
  }
}
</style>
